// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1p5AJ","sendOtp":"AuthorizeToLogin_sendOtp__3YpP7"};